import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useEffect} from "react";
import './styleModal.css';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../Components/CustomSnackbar';
import { DescriptionComponents } from '../LoadingData/LoadingConnectionComponents';
import ModalMapConnection from './ModalMapConnection';
import { CABLE } from '../Constants/ConstantsOptics';
import ModalRouteCableMap from './ModalRouteCableMap';
import ModalRouteCableMapSpecifically from './ModalRouteCableMapSpecifically';

const ModalDescriptionComponentSpecifically = ({ open, onClose, id, type, flag, groupedCoordinatesWithColorTypeAndWidth, wellData, fobLocationData, couplingLocationData,
  ponBoxLocationData, pillarData}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [dataStartCable, setDataStartCable] = useState([]);
  const [dataEndCable, setDataEndCable] = useState([]);
  const [dataConnectionCable, setDataConnectionCable] = useState([]);
  const [flagVisibleCable, setFlagVisibleCable] = useState(false);
  const [dataConnectionPillar, setDataConnectionPillar] = useState([]);
  const [flagVisiblePillar, setFlagVisiblePillar] = useState(false);
  const [dataConnectionWell, setDataConnectionWell] = useState([]);
  const [flagVisibleWell, setFlagVisibleWell] = useState(false);
  const [dataConnectionCoupling, setDataConnectionCoupling] = useState([]);
  const [flagVisibleCoupling, setFlagVisibleCoupling] = useState(false);
  const [dataConnectionFob, setDataConnectionFob] = useState([]);
  const [flagVisibleFob, setFlagVisibleFob] = useState(false);
  const [dataConnectionHouse, setDataConnectionHouse] = useState([]);
  const [flagVisibleHouse, setFlagVisibleHouse] = useState(false);
  const [dataConnectionPonBox, setDataConnectionPonBox] = useState([]);
  const [flagVisiblePonBox, setFlagVisiblePonBox] = useState(false);
  const [openVewingModal,  setOpenVewingModal] = useState(false); 

  const [filteredWellData,  setFilteredWellData] = useState([]); 
  const [filteredFobData,  setFilteredFobData] = useState([]); 
  const [filteredCouplingData,  setFilteredCouplingData] = useState([]); 
  const [filteredPonBoxData,  setFilteredPonBoxData] = useState([]); 
  const [filteredPillarData,  setFilteredPillarData] = useState([]); 

   const [openModalRouteCable, setOpenModalRouteCable] = useState(false);
   const [lineId, setLineId] = useState('');

  // Well
  useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const wellIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.wellId) 
        .filter(id => id !== null); 

      const filteredData = wellData.filter(well => wellIds.includes(well.id));
      setFilteredWellData(filteredData);    
    } else {
      
    }
  }, [dataConnectionCable, wellData]); 

  // Fob
  useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const fobIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.fobLocationId) 
        .filter(id => id !== null);

      const filteredData = fobLocationData.filter(fob => fobIds.includes(fob.id));
      setFilteredFobData(filteredData);    
    } else {     
    }
  }, [dataConnectionCable, fobLocationData]); 

  // Coupling
  useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const couplingIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.couplingLocationId) 
        .filter(id => id !== null);

      const filteredData = couplingLocationData.filter(coupling => couplingIds.includes(coupling.id));
      setFilteredCouplingData(filteredData);    
    } else {     
    }
  }, [dataConnectionCable, couplingLocationData]); 

  // PonBox
  useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const ponBoxIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.ponBoxLocationId) 
        .filter(id => id !== null);

      const filteredData = ponBoxLocationData.filter(ponBox => ponBoxIds.includes(ponBox.id));
      setFilteredPonBoxData(filteredData);    
    } else {     
    }
  }, [dataConnectionCable, ponBoxLocationData]); 

  // Pillar
  useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const pillarIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.pillarId) 
        .filter(id => id !== null);

      const filteredData = pillarData.filter(pillar => pillarIds.includes(pillar.id));
      setFilteredPillarData(filteredData);    
    } else {     
    }
  }, [dataConnectionCable, pillarData]); 


  useEffect(() => {
    if (open) {
      descriptionComponents();
    }
  }, [open]);

  const descriptionComponents = async () => {
     DescriptionComponents(type, id, showSnackbar, setFlagVisiblePillar, setFlagVisibleWell, setFlagVisibleCoupling,
         setFlagVisibleFob, setDataStartCable, setDataEndCable, setDataConnectionCable, setFlagVisibleCable,setDataConnectionPillar,
         setDataConnectionWell, setDataConnectionCoupling, setDataConnectionFob, setDataConnectionHouse, setFlagVisibleHouse,
         setFlagVisiblePonBox, setDataConnectionPonBox);       
  } 


  const handleClose = () => {
    onClose(); 
    setDataEndCable([]);
    setDataStartCable([]);
    setDataConnectionCable([]);
    setDataConnectionPillar([]);
    setDataConnectionCoupling([]);
    setDataConnectionFob([]);
    setDataConnectionPonBox([]);
    setDataConnectionHouse([]);

    setFlagVisibleCable(false)
    setFlagVisiblePillar(false);
    setFlagVisibleWell(false);
    setFlagVisibleCoupling(false);
    setFlagVisibleFob(false);
    setFlagVisibleHouse(false);
    setFlagVisiblePonBox(false);
    
    setFilteredWellData([]);
    setFilteredFobData([]);
    setFilteredCouplingData([]);
    setFilteredPonBoxData([]);
  };

  const openModalMapConnection = () => {
    setOpenVewingModal(true);
  }; 

  const openModalRouteOptic = (id) => {
        setLineId(id);
        setOpenModalRouteCable(true);
    
    }; 

    return (
    <Dialog open={open} className="modalStyle">
      <DialogContent>
      <div style={{ position: 'relative' }}> 
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>
        {flag} ID: {id}
      </label>
      {type === "Cable" && (
        <button
          className='buttonIsModal'
          onClick={openModalMapConnection}
          style={{
            position: 'absolute', 
            top: '0',  
            right: '0',
            textShadow: '2px 2px 4px rgb(61, 61, 61)' 
          }}
        >
          Связи на карте
        </button>
      )}
    </div>
      <hr className='horizontalLineModal'/>
      <div>
       <div style={{  display: flagVisibleCable ? 'flex' : 'none', justifyContent: 'center' }}>
        <div className='divStartEndCableModal'>
        {dataStartCable.length === 0 ? (
          <label style={{ color: '#ff9c9c',textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Start кабеля не указан</label>
          ) : (
              dataStartCable.map((item) => (
                  <>
                      {item.houseId ? (
                          <label style={{ color: '#dfab01', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Start кабеля:
                            <hr className='horizontalLine2Modal'/>
  
                            <span style={{ color: '#cccccc', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>ID: {item.houseId}<br/>{item.street}<br/> дом. {item.houseNumber}<br/> под. {item.entrance}</span></label>
                      ) : null}
                      {item.wellId ? (
                          <label style={{ color: '#dfab01', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Start кабеля:
                           <hr className='horizontalLine2Modal'/> 
                           <span style={{ color: '#cccccc', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Колодец: ID {item.wellId}</span></label> 
                      ) : null}
                      {item.pillarId ? (
                         <label style={{ color: '#dfab01', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Start кабеля:
                         <hr className='horizontalLine2Modal'/> 
                         <span style={{ color: '#cccccc',textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Опора: ID {item.pillarId}</span></label>                     
                      ) : null}
                       
                  </>
              ))
          )}
        </div>
        <img style={{marginLeft:'10px',marginRight: '10px', width: '40px', height: '40px'}} src='./vektor.png' alt='вектор' />
      
        <div className='divStartEndCableModal'>
        {dataEndCable.length === 0 ? (
          <label style={{ color: '#ff9c9c',textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>End кабеля не указан</label>
          ) : (
              dataEndCable.map((item) => (
                  <>
                      {item.houseId ? (
                          <label style={{ color: '#dfab01', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>End кабеля:
                            <hr className='horizontalLine2Modal'/>
                            <span style={{ color: '#cccccc',textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>ID: {item.houseId}<br/>{item.street}<br/> дом. {item.houseNumber}<br/> под. {item.entrance}</span></label>
                      ) : null}
                      {item.wellId ? (
                          <label style={{ color: '#dfab01',textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>End кабеля:
                           <hr className='horizontalLine2Modal'/> 
                           <span style={{ color: '#cccccc',textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Колодец: ID {item.wellId}</span></label> 
                      ) : null}
                      {item.pillarId ? (
                         <label style={{ color: '#dfab01',textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>End кабеля:
                         <hr className='horizontalLine2Modal'/> 
                         <span style={{ color: '#cccccc',textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Опора: ID {item.pillarId}</span></label>                     
                      ) : null}
                       
                  </>
              ))
          )}
        </div>       
      </div> 
      <hr className='horizontalLineModal' style={{ display: flagVisibleCable ? 'block' : 'none' }} />     
      </div>

      <div style={{justifyContent: 'center'}}>
        <label style={{ color: '#dfab01', display: flagVisibleCable ? 'block' : 'none', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Связи</label>

    {flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
      <>
        {dataConnectionCable.listConnectionCable.some(item => item.couplingLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./сoupling.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Муфта</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionCable.listConnectionCable.map((item, index) => (
                    item.couplingLocationId !== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.couplingLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.couplingLatitude}, {item.couplingLongitude}</span>      
                        </div>
                    )
                ))}
           </div>
        )}
     </>
    )}

    {flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
      <>
        {dataConnectionCable.listConnectionCable.some(item => item.ponBoxLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./ponbox.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Пон-бокс</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionCable.listConnectionCable.map((item, index) => (
                    item.ponBoxLocationId !== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.ponBoxLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.ponBoxLatitude}, {item.ponBoxLongitude}</span>      
                        </div>
                    )
                ))}
           </div>
        )}
     </>
    )}


{flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
     {dataConnectionCable.listConnectionCable.some(item => item.fobLocationId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./fob.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>Фоб</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
        item.fobLocationId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.fobLocationId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.fobLatitude}, {item.fobLongitude}</span>      
          </div>
        )
      ))}
      </div>
    )}
    </>
  )}


 
  {flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
     {dataConnectionCable.listConnectionCable.some(item => item.pillarId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./pillar.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Опора</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
        item.pillarId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.pillarId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.pillarLatitude}, {item.pillarLongitude}</span>      
          </div>
        )
      ))}
      </div>
    )}
    </>
  )}




{flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
    {dataConnectionCable.listConnectionCable.some(item => item.wellId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./manhole.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px",textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Колодец</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
       
        item.wellId !== null && (
          
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.wellId}</span>
          <br/>
         
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.wellLatitude}, {item.wellLongitude}</span>      
          </div>
        )
      ))}
       </div>
    )}
    </>
  )}

{flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
    {dataConnectionCable.listConnectionCable.some(item => item.telecomCenterCassetteId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cassette.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px",textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Сплайс-кассета</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
       
        item.telecomCenterCassetteId !== null && (
          
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.telecomCenterCassetteId}</span>
        
          </div>
        )
      ))}
       </div>
    )}
    </>
  )}

{flagVisibleCable && dataConnectionCable && dataConnectionCable.houses && dataConnectionCable.houses.length > 0 && (
    <>
     {dataConnectionCable.listConnectionCable.some(item => item.houseId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./house.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Дом</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.houses.map((item, index) => {
        const connectionItem = dataConnectionCable.listConnectionCable.find(connection => connection.houseId === item.id);
        return (
          <div className='divBodyConnectModal' key={index}> 
            <span style={{fontWeight: 'bold'}}>ID: {connectionItem ? connectionItem.houseId : 'N/A'}</span>
            <br/>
            <span style={{fontSize: "14px", color: "#202020"}}>
              {item.street}, дом. {item.house} под.{connectionItem ? connectionItem.entrance : 'N/A'}
            </span>      
          </div>
        );
      })}
       </div>
    )}
    </>
)}



  {flagVisibleCable && dataConnectionCable && dataConnectionCable.listConnectionCable && dataConnectionCable.listConnectionCable.length > 0 && (
    <>
     {dataConnectionCable.listConnectionCable.some(item => item.lineParentId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Кабель родитель</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCable.listConnectionCable.map((item, index) => (
        item.lineParentId !== null && (
          <div className='divBodyConnectModa2' key={index} onClick={() => openModalRouteOptic(item.lineParentId)}> 
            <span style={{fontWeight: 'bold'}}>
              ID: {item.lineParentId}
            </span>      
          </div>
        )
      ))}
        </div>
    )}
    </>
  )}
        <hr className='horizontalLineModal'/>

    {/* опора */}
    <div style={{justifyContent: 'center'}}>
      <label style={{ color: '#dfab01', display: flagVisiblePillar ? 'block' : 'none', fontSize: "18px" }}>Связи</label>

      {flagVisiblePillar && dataConnectionPillar.length > 0 && (
      <>
          {dataConnectionPillar.some(item => item.couplingLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./сoupling.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px",textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Муфта</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionPillar.map((item, index) => (
                    item.couplingLocationId!== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.couplingLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.couplingLatitude}, {item.couplingLongitude}</span>      
                        </div>
                    )
                ))}
           </div>
          )}
     </>
    )}

{flagVisiblePillar && dataConnectionPillar.length > 0 && (
      <>
        {dataConnectionPillar.some(item => item.ponBoxLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./fob.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Пон-бокс</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionPillar.map((item, index) => (
                    item.ponBoxLocationId!== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.ponBoxLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.ponBoxLatitude}, {item.ponBoxLongitude}</span>      
                        </div>
                    )
                ))}
           </div>
        )}
     </>
    )} 

{flagVisiblePillar && dataConnectionPillar.length > 0 && (
      <>
        {dataConnectionPillar.some(item => item.fobLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./fob.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Фоб</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionPillar.map((item, index) => (
                    item.fobLocationId!== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.fobLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.fobLatitude}, {item.fobLongitude}</span>      
                        </div>
                    )
                ))}
           </div>
        )}
     </>
    )}

    

  {flagVisiblePillar && dataConnectionPillar.length > 0 && (
      <>
                {dataConnectionPillar.some(item => item.highwayLineId !== null) && (

           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Кабель</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionPillar.map((item, index) => (
                    item.highwayLineId !== null && (
                        <div className='divBodyConnectModa2' key={index} onClick={() => openModalRouteOptic(item.highwayLineId)}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.highwayLineId}</span>
                        </div>
                    )
                ))}
           </div>
                )}
     </>
    )}

    </div>

    {/* well */}
    <div style={{justifyContent: 'center'}}>
          <label style={{ color: '#dfab01', display: flagVisibleWell ? 'block' : 'none', fontSize: "18px" }}>Связи</label>

          {flagVisibleWell && dataConnectionWell.length > 0 && (
          <>
              {dataConnectionWell.some(item => item.couplingLocationId !== null) && (
              <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                    <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./сoupling.png' alt='вектор' />
                    <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Муфта</label>
                    <hr className='horizontalLine2Modal'/>
                    {dataConnectionWell.map((item, index) => (
                        item.couplingLocationId!== null && (
                            <div className='divBodyConnectModal' key={index}> 
                                <span style={{fontWeight: 'bold'}}>ID: {item.couplingLocationId}</span>
                                <br/>
                                <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.couplingLatitude}, {item.couplingLongitude}</span>      
                            </div>
                        )
                    ))}
              </div>
              )}
        </>
        )}

    {flagVisibleWell && dataConnectionWell.length > 0 && (
          <>
            {dataConnectionWell.some(item => item.fobLocationId !== null) && (
              <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                    <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./fob.png' alt='вектор' />
                    <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Фоб</label>
                    <hr className='horizontalLine2Modal'/>
                    {dataConnectionWell.map((item, index) => (
                        item.fobLocationId!== null && (
                            <div className='divBodyConnectModal' key={index}> 
                                <span style={{fontWeight: 'bold'}}>ID: {item.fobLocationId}</span>
                                <br/>
                                <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.fobLatitude}, {item.fobLongitude}</span>      
                            </div>
                        )
                    ))}
              </div>
            )}
        </>
        )}

    

      {flagVisibleWell && dataConnectionWell.length > 0 && (
          <>
                    {dataConnectionWell.some(item => item.highwayLineId !== null) && (

              <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                    <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
                    <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Кабель</label>
                    <hr className='horizontalLine2Modal'/>
                    {dataConnectionWell.map((item, index) => (
                        item.highwayLineId !== null && (
                            <div className='divBodyConnectModa2' key={index}  onClick={() => openModalRouteOptic(item.highwayLineId)}> 
                                <span style={{fontWeight: 'bold'}}>ID: {item.highwayLineId}</span>
                            </div>
                        )
                    ))}
              </div>
                    )}
        </>
        )}

    </div>

    {/* Coupling */}
    <div style={{justifyContent: 'center'}}>
        <label style={{ color: '#dfab01', display: flagVisibleCoupling ? 'block' : 'none', fontSize: "18px" }}>Связи</label>

     {flagVisibleCoupling && dataConnectionCoupling && dataConnectionCoupling.houses && dataConnectionCoupling.houses.length > 0 && (
      <>
      {dataConnectionCoupling.listConnectionCoupling.some(item => item.houseId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./house.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Дом</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCoupling.houses.map((item, index) => {
        const connectionItem = dataConnectionCoupling.listConnectionCoupling.find(connection => connection.houseId === item.id);
        return (
          <div className='divBodyConnectModal' key={index}> 
            <span style={{fontWeight: 'bold'}}>ID: {connectionItem ? connectionItem.houseId : 'N/A'}</span>
            <br/>
            <span style={{fontSize: "14px", color: "#202020"}}>
              {item.street}, дом. {item.house} под.{connectionItem ? connectionItem.entrance : 'N/A'}
            </span>      
          </div>
        );
      })}
      </div>
     )}
     </>
    )}

{flagVisibleCoupling && dataConnectionCoupling && dataConnectionCoupling.listConnectionCoupling && dataConnectionCoupling.listConnectionCoupling.length > 0 && (
    <>
     {dataConnectionCoupling.listConnectionCoupling.some(item => item.pillarId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./pillar.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>Опора</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCoupling.listConnectionCoupling.map((item, index) => (
        item.pillarId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.pillarId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.pillarLatitude}, {item.pillarLongitude}</span>      
          </div>
        )
      ))}
      </div>
    )}
    </>
  )}




{flagVisibleCoupling && dataConnectionCoupling && dataConnectionCoupling.listConnectionCoupling && dataConnectionCoupling.listConnectionCoupling.length > 0 && (
    <>
    {dataConnectionCoupling.listConnectionCoupling.some(item => item.wellId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./manhole.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Колодец</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCoupling.listConnectionCoupling.map((item, index) => (
        item.wellId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.wellId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.wellLatitude}, {item.wellLongitude}</span>      
          </div>
        )
      ))}
       </div>
    )}
    </>
  )}

{flagVisibleCoupling && dataConnectionCoupling && dataConnectionCoupling.listConnectionCoupling && dataConnectionCoupling.listConnectionCoupling.length > 0 && (
    <>
     {dataConnectionCoupling.listConnectionCoupling.some(item => item.highwayLineId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Кабель</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionCoupling.listConnectionCoupling.map((item, index) => (
        item.highwayLineId !== null && (
          <div className='divBodyConnectModa2' key={index} onClick={() => openModalRouteOptic(item.highwayLineId)}>
             <span style={{fontWeight: 'bold'}}>
                ID: {item.highwayLineId}
             </span>      
          </div>
        )
      ))}
        </div>
    )}
    </>
  )}

    </div>

     {/* Fob */}
     <div style={{justifyContent: 'center'}}>
        <label style={{ color: '#dfab01', display: flagVisibleFob ? 'block' : 'none', fontSize: "18px" }}>Связи</label>

     {flagVisibleFob && dataConnectionFob && dataConnectionFob.houses && dataConnectionFob.houses.length > 0 && (
      <>
      {dataConnectionFob.listConnectionFob.some(item => item.houseId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./house.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Дом</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionFob.houses.map((item, index) => {
        const connectionItem = dataConnectionFob.listConnectionFob.find(connection => connection.houseId === item.id);
        return (
          <div className='divBodyConnectModal' key={index}> 
            <span style={{fontWeight: 'bold'}}>ID: {connectionItem ? connectionItem.houseId : 'N/A'}</span>
            <br/>
            <span style={{fontSize: "14px", color: "#202020"}}>
              {item.street}, дом. {item.house} под.{connectionItem ? connectionItem.entrance : 'N/A'}
            </span>      
          </div>
        );
      })}
      </div>
     )}
     </>
    )}

{flagVisibleFob && dataConnectionFob && dataConnectionFob.listConnectionFob && dataConnectionFob.listConnectionFob.length > 0 && (
    <>
     {dataConnectionFob.listConnectionFob.some(item => item.pillarId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./pillar.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Опора</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionFob.listConnectionFob.map((item, index) => (
        item.pillarId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.pillarId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.pillarLatitude}, {item.pillarLongitude}</span>      
          </div>
        )
      ))}
      </div>
    )}
    </>
  )}




{flagVisibleFob && dataConnectionFob && dataConnectionFob.listConnectionFob && dataConnectionFob.listConnectionFob.length > 0 && (
    <>
    {dataConnectionFob.listConnectionFob.some(item => item.wellId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./manhole.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Колодец</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionFob.listConnectionFob.map((item, index) => (
        item.wellId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.wellId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.wellLatitude}, {item.wellLongitude}</span>      
          </div>
        )
      ))}
       </div>
    )}
    </>
  )}

{flagVisibleFob && dataConnectionFob && dataConnectionFob.listConnectionFob && dataConnectionFob.listConnectionFob.length > 0 && (
    <>
     {dataConnectionFob.listConnectionFob.some(item => item.highwayLineId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Кабель</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionFob.listConnectionFob.map((item, index) => (
        item.highwayLineId !== null && (
          <div className='divBodyConnectModa2' key={index} onClick={() => openModalRouteOptic(item.highwayLineId)}> 
            <span style={{fontWeight: 'bold'}}>
                ID: {item.highwayLineId}
            </span>      
          </div>
        )
      ))}
        </div>
    )}
    </>
  )}

    </div>


     {/* House */}
     <div style={{justifyContent: 'center'}}>
      <label style={{ color: '#dfab01', display: flagVisibleHouse ? 'block' : 'none', fontSize: "18px" }}>Связи</label>

      {flagVisibleHouse && dataConnectionHouse.length > 0 && (
      <>
          {dataConnectionHouse.some(item => item.couplingLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./сoupling.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Муфта</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionHouse.map((item, index) => (
                    item.couplingLocationId!== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.couplingLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.couplingLatitude}, {item.couplingLongitude}</span>      
                        </div>
                    )
                ))}
           </div>
          )}
     </>
    )}

{flagVisibleHouse && dataConnectionHouse.length > 0 && (
      <>
        {dataConnectionHouse.some(item => item.fobLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./fob.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Фоб</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionHouse.map((item, index) => (
                    item.fobLocationId!== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.fobLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.fobLatitude}, {item.fobLongitude}</span>      
                        </div>
                    )
                ))}
           </div>
        )}
     </>
    )}

{flagVisibleHouse && dataConnectionHouse.length > 0 && (
      <>
        {dataConnectionHouse.some(item => item.ponBoxLocationId !== null) && (
           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./ponbox.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Пон-бокс</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionHouse.map((item, index) => (
                    item.ponBoxLocationId!== null && (
                        <div className='divBodyConnectModal' key={index}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.ponBoxLocationId}</span>
                            <br/>
                            <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.ponBoxLatitude}, {item.ponBoxLongitude}</span>      
                        </div>
                    )
                ))}
           </div>
        )}
     </>
    )}

  {flagVisibleHouse && dataConnectionHouse.length > 0 && (
      <>
                {dataConnectionHouse.some(item => item.highwayLineId !== null) && (

           <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
                <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Кабель</label>
                <hr className='horizontalLine2Modal'/>
                {dataConnectionHouse.map((item, index) => (
                    item.highwayLineId !== null && (
                        <div className='divBodyConnectModa2' key={index} onClick={() => openModalRouteOptic(item.highwayLineId)}> 
                            <span style={{fontWeight: 'bold'}}>ID: {item.highwayLineId}</span>
                        </div>
                    )
                ))}
           </div>
                )}
     </>
    )}




     {/* PonBox */}
     <div style={{justifyContent: 'center'}}>
        <label style={{ color: '#dfab01', display: flagVisiblePonBox ? 'block' : 'none', fontSize: "18px" }}>Связи</label>

     {flagVisiblePonBox && dataConnectionPonBox && dataConnectionPonBox.houses && dataConnectionPonBox.houses.length > 0 && (
      <>
      {dataConnectionPonBox.listConnectionPonBox.some(item => item.houseId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./house.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Дом</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionPonBox.houses.map((item, index) => {
        const connectionItem = dataConnectionPonBox.listConnectionPonBox.find(connection => connection.houseId === item.id);
        return (
          <div className='divBodyConnectModal' key={index}> 
            <span style={{fontWeight: 'bold'}}>ID: {connectionItem ? connectionItem.houseId : 'N/A'}</span>
            <br/>
            <span style={{fontSize: "14px", color: "#202020"}}>
              {item.street}, дом. {item.house} под.{connectionItem ? connectionItem.entrance : 'N/A'}
            </span>      
          </div>
        );
      })}
      </div>
     )}
     </>
    )}

{flagVisiblePonBox && dataConnectionPonBox && dataConnectionPonBox.listConnectionPonBox && dataConnectionPonBox.listConnectionPonBox.length > 0 && (
    <>
     {dataConnectionPonBox.listConnectionPonBox.some(item => item.pillarId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./pillar.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Опора</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionPonBox.listConnectionPonBox.map((item, index) => (
        item.pillarId !== null && (
          <div className='divBodyConnectModal' key={index}> <span style={{fontWeight: 'bold'}}>ID: {item.pillarId}</span>
          <br/>
          <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.pillarLatitude}, {item.pillarLongitude}</span>      
          </div>
        )
      ))}
      </div>
    )}
    </>
  )}

{flagVisiblePonBox && dataConnectionPonBox && dataConnectionPonBox.listConnectionPonBox && dataConnectionPonBox.listConnectionPonBox.length > 0 && (
    <>
     {dataConnectionPonBox.listConnectionPonBox.some(item => item.highwayLineId !== null) && (
      <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
      <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
      <label style={{ color: '#dfab01', fontSize: "18px",textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Кабель</label>
      <hr className='horizontalLine2Modal'/>
      {dataConnectionPonBox.listConnectionPonBox.map((item, index) => (
        item.highwayLineId !== null && (
          <div key={index} className='divBodyConnectModa2' onClick={() => openModalRouteOptic(item.highwayLineId)}> 
            <span style={{fontWeight: 'bold'}}>
                ID: {item.highwayLineId}
            </span>    
          </div>
        )
      ))}
        </div>
    )}
    </>
  )}

    </div>


    </div>
    </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>

      {/* Маршрут кабеля*/}
      <ModalRouteCableMapSpecifically
        open={openModalRouteCable}
        onClose={() => setOpenModalRouteCable(false)}
        lineId={lineId}
        setLineId={setLineId}
      />

      {type === CABLE && (
        <ModalMapConnection
          open={openVewingModal}
          onClose={() => setOpenVewingModal(false)}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth[id]}
          filteredWellData={filteredWellData}
          filteredFobData={filteredFobData}
          filteredCouplingData={filteredCouplingData}
          filteredPonBoxData={filteredPonBoxData}
          filteredPillarData={filteredPillarData}
        />
      )}

      {/* Snackbar */}
      <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
          ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
            }
          }}
        />
    </Dialog>
  );
}

export default ModalDescriptionComponentSpecifically;
